import React, { useState, useEffect } from "react";

import { Controller, useForm } from "react-hook-form";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import TextInputTwoRow from "components/GenericComponent/TextInputTwoRow";
import NumberInput from "components/GenericComponent/NumberInput";
import NumberField from "components/GenericComponent/NumberField";
import NumberFormat from "react-number-format";
import { formatNumber, formatMoney } from "utils/currencyFormat";
import {
  dsKieuLaiSuatDuNoGoc,
  layKieuLaiSuatDuNoGoc,
} from "components/CommonComponent/ThemMoiTraGop/DuNoGiamDan";

const DuNoGiamDan = (props) => {
  let {
    data,
    register,
    chonngaygiaodich,
    IsEditChoVay,
    func,
    control,
    errors,
    SuDungPhiPhat_DongLai_TatToan,
    ChoPhepSuaMaHopDong,
    TypeDuNo,
    isMoney88,
    chiPhiVayTheoNgay,
  } = props;
  let {
    onChangeNgayVay,
    onChangeAttNumberChoVay,
    onChangeTypePaid,
    onChangeTypePaidTraGop,
    onChangeBeforeAfterDuNoGoc,
    onChangeKieuLaiSuatDuNoGoc,
    onChangeAttTextChoVay,
    onChangeStatusPaidHo,
    onChangeNgayThanhToan,
  } = func;

  let {
    NgayVay,
    ChoVayId,
    Sotienvay,
    StatusPaidHo,
    BocTrongVong,
    CountTypePaid,
    BeforeAfter,
    Note,
    ValueLai,
    TypePaid,
    TienThuHangKy,
    LaiTraGop,
    TienCatTruoc,
    NgayThanhToan,
    PhiThanhToanSom,
    ChiPhiVay,
    ChiPhiVay1,
    PhiBaoHiem,
    Code,
    KieuLaiSuat,
  } = data;
  //Dư nợ gốc bằng nhau của cấu hình isMoney88: cho chọn kỳ Ngày/Tuần/Tháng định kỳ/Tháng
  const chonKyThoiGianVay = isMoney88 === true && TypeDuNo === 2;
  const dsKieuLaiSuat = chonKyThoiGianVay ? dsKieuLaiSuatDuNoGoc(TypePaid) : [];
  const donViChiPhiVay = chiPhiVayTheoNgay === false ? "Tháng" : "Ngày";
  return (
    <>
      <div className="col-md-4">
        <label className="label-control color7-bold">
          Ngày vay <span className="canh-bao-red">*</span>
        </label>
        <br />
        <DateTimePicker
          onChange={onChangeNgayVay}
          value={NgayVay}
          // customInputRef={register}
          customInputRef={register({
            required: "Hãy nhập ngày vay",
          })}
          readOnly={!chonngaygiaodich || IsEditChoVay}
          name="NgayVay"
          customInput={<input name="NgayVay" ref={register}></input>}
        ></DateTimePicker>
        <span className="canh-bao-red">
          {errors.NgayVay && errors.NgayVay.message}
        </span>
      </div>
      {TypeDuNo === 1 && (
        <div className="col-md-4">
          <label className="label-control color7-bold">
            Ngày bắt đầu tính lãi <span className="canh-bao-red">*</span>
          </label>
          <br />
          <DateTimePicker
            onChange={onChangeNgayThanhToan}
            value={NgayThanhToan}
            customInputRef={register}
            readOnly={IsEditChoVay}
            name="NgayThanhToan"
            customInput={<input name="NgayThanhToan" ref={register}></input>}
          ></DateTimePicker>
          <span className="canh-bao-red">
            {errors.NgayVay && errors.NgayVay.message}
          </span>
        </div>
      )}
      <div className="col-md-4">
        <TextInputTwoRow
          labelClass="col-md-2 label-control"
          inputClass="form-control input-sm"
          wrapperClass="form-group row"
          labelText="Mã hợp đồng"
          placeholder="Mã hợp đồng"
          inputProps={{
            ref: register,
            name: "Code",
            readOnly: IsEditChoVay,
          }}
        ></TextInputTwoRow>
      </div>
      <div className="col-md-4">
        <NumberInput
          labelClass="col-md-4 label-control"
          inputClass="form-control input-sm"
          inputWrapClass="col-md-8"
          wrapperClass="row"
          labelText="Tổng tiền vay"
          starRed="*"
          placeholder="10,000,000"
          inputProps={{
            name: "Sotienvay",
            value: Sotienvay,
            onChange: onChangeAttNumberChoVay("Sotienvay"),
            rules: {
              required: "Hãy nhập số tiền vay",
            },
            control: control,
            readOnly: IsEditChoVay,
          }}
          error={errors.Sotienvay}
        ></NumberInput>
      </div>
      <div className="col-md-4">
        <label className="label-control color7-bold">
          Thời gian vay <span className="canh-bao-red">*</span>
        </label>
        <br />
        <div class="row">
          <div className="col-md-7" style={{ paddingRight: "0px" }}>
            <NumberField
              className="form-control input-sm"
              name={"BocTrongVong"}
              value={BocTrongVong}
              onChange={onChangeAttNumberChoVay("BocTrongVong")}
              // inputRef={register}
              placeholder={"50"}
              inputRef={register({
                required: "Hãy nhập thời gian vay",
              })}
            ></NumberField>
            <span className="canh-bao-red">
              {errors.CountTypePaid && errors.CountTypePaid.message}
            </span>
          </div>
          <div className="col-md-5 color7" style={{ paddingLeft: "10px", paddingTop:"10px" }}>
            {chonKyThoiGianVay ? "   kỳ" : "   Tháng"}
          </div>
        </div>
        <span className="canh-bao-red">
          {errors.CountTypePaid && errors.CountTypePaid.message}
        </span>
      </div>
      {chonKyThoiGianVay && (
        <div className="col-md-4">
          <label className="label-control color7-bold">
            Kỳ đóng lãi <span className="canh-bao-red">*</span>
          </label>
          <br />
          <div class="row">
            <div className="col-md-7" style={{ paddingRight: "0px" }}>
              <Controller
                name="CountTypePaid"
                rules={{
                  required: "Hãy nhập kỳ đóng lãi",
                }}
                control={control}
                defaultValue={CountTypePaid}
                className="form-control left input-sm"
                as={NumberFormat}
                disabled={IsEditChoVay}
              />
              <span className="canh-bao-red">
                {errors.CountTypePaid && errors.CountTypePaid.message}
              </span>
            </div>
            <div className="col-md-5" style={{ paddingLeft: "0px" }}>
              <select
                name="TypePaid"
                ref={register}
                className="form-control right input-sm select-v2"
                onChange={onChangeTypePaidTraGop()}
                value={TypePaid}
                defaultValue={TypePaid}
                disabled={IsEditChoVay}
              >
                <option value="1">Ngày</option>
                <option value="4">Tuần</option>
                <option value="3">Tháng định kỳ</option>
                <option value="2">Tháng</option>
              </select>
            </div>
          </div>
        </div>
      )}
      {chonKyThoiGianVay && (
        <div className="col-md-4">
          <label className="label-control color7-bold">
            Kiểu thu lãi <span className="canh-bao-red">*</span>
          </label>
          <br />
          {/* Không register: giá trị lấy từ choVayEdit.BeforeAfter lúc submit */}
          <select
            className="form-control input-sm select-v2"
            onChange={onChangeBeforeAfterDuNoGoc()}
            value={Number(BeforeAfter) === 2 ? 2 : 1}
            disabled={IsEditChoVay}
          >
            <option value="1">Thu lãi sau</option>
            <option value="2">Thu lãi trước</option>
          </select>
        </div>
      )}
      <div className="col-md-4">
        <label className="label-control color7-bold">
          {chonKyThoiGianVay ? "Lãi suất" : `Chi phí vay(% ${donViChiPhiVay})`}{" "}
          <span className="canh-bao-red">*</span>
        </label>
        <br />
        {/* Giữ một Controller cho cả 2 kiểu để đổi Loại giảm dần không mất số đã nhập */}
        <div class="row">
          <div
            className={chonKyThoiGianVay ? "col-md-7" : "col-md-12"}
            style={chonKyThoiGianVay ? { paddingRight: "0px" } : {}}
          >
            <Controller
              name="ChiPhiVay"
              rules={{
                required: "Hãy nhập số",
              }}
              control={control}
              defaultValue={ChiPhiVay1}
              className={
                chonKyThoiGianVay
                  ? "form-control left input-sm"
                  : "form-control input-sm"
              }
              // onChange, onBlur, value, name, ref inejcted to the component
              as={NumberFormat}
              placeholder={"%"}
            />
          </div>
          {chonKyThoiGianVay && (
            <div className="col-md-5" style={{ paddingLeft: "0px" }}>
              {dsKieuLaiSuat.length > 0 ? (
                <select
                  className="form-control right input-sm select-v2"
                  onChange={onChangeKieuLaiSuatDuNoGoc()}
                  value={layKieuLaiSuatDuNoGoc(TypePaid, KieuLaiSuat)}
                  disabled={IsEditChoVay}
                >
                  {dsKieuLaiSuat.map((item) => (
                    <option key={item.value} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>
              ) : (
                <div
                  className="color7"
                  style={{ paddingLeft: "10px", paddingTop: "10px" }}
                >
                  % Định kỳ
                </div>
              )}
            </div>
          )}
        </div>
      </div>
        {SuDungPhiPhat_DongLai_TatToan &&
          PhiThanhToanSom > 0 &&
          ChoVayId > 0 && (
            <div className="col-md-4">
              <label className="label-control color7-bold">
                Phí thanh toán sớm
              </label>
              <Controller
                name="PhiThanhToanSom"
                control={control}
                defaultValue={formatMoney(PhiThanhToanSom, 2)}
                className="form-control input-sm"
                // onChange, onBlur, value, name, ref inejcted to the component
                as={NumberFormat}
                placeholder={"%"}
              />
            </div>
          )}
        {!SuDungPhiPhat_DongLai_TatToan && (
          <div className="col-md-4">
            <label className="label-control color7-bold">
              Phí thanh toán sớm
            </label>
            <Controller
              name="PhiThanhToanSom"
              control={control}
              defaultValue={formatMoney(PhiThanhToanSom, 2)}
              className="form-control input-sm"
              // onChange, onBlur, value, name, ref inejcted to the component
              as={NumberFormat}
              placeholder={"%"}
            />
          </div>
        )}
        <div className="col-md-4">
          <label className="label-control color7-bold">Phí bảo hiểm</label>
          <Controller
            name="PhiBaoHiem"
            control={control}
            defaultValue={formatMoney(PhiBaoHiem, 2)}
            className="form-control input-sm"
            // onChange, onBlur, value, name, ref inejcted to the component
            as={NumberFormat}
            placeholder={"%"}
          />
        </div>
    </>
  );
};
export default DuNoGiamDan;
